import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Get current Australian financial year
 * FY runs July 1 - June 30, named by end year (e.g., FY2026 = Jul 2025 - Jun 2026)
 */
export function getCurrentFinancialYear() {
  const now = new Date();
  const month = now.getMonth(); // 0-11
  const year = now.getFullYear();
  return month >= 6 ? year + 1 : year; // July onwards = next FY
}

/**
 * Format financial year display (e.g., "2025/2026")
 */
export function formatFinancialYear(year) {
  return `${year - 1}/${year}`;
}

/**
 * Format number with locale and decimals
 */
export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined) return '0';
  return Number(value).toLocaleString('en-AU', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

/**
 * Format file size in human readable format
 */
export function formatFileSize(bytes) {
  if (!bytes) return '0 B';
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
}

/**
 * Format date for display
 */
export function formatDate(date, options = {}) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options
  });
}

/**
 * Format date with time (e.g., "14 Feb 2026, 3:45 PM")
 */
export function formatDateTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
}

/**
 * Scope colors for charts (Scope 1 & 2 only)
 */
export const SCOPE_COLORS = {
  'Scope 1': '#0d5c2e',  // Dark Green
  'Scope 2': '#2563eb',  // Blue
};

/**
 * Category display names
 */
export const CATEGORY_LABELS = {
  electricity: 'Electricity',
  electricity_greenpower: 'Electricity (GreenPower)',
  fuel_petrol: 'Fuel - Petrol',
  fuel_diesel: 'Fuel - Diesel',
  fuel_lpg: 'Fuel - LPG',
  fuel: 'Fuel (Generic)',
  natural_gas: 'Natural Gas',
  water: 'Water',
  flight_short: 'Flight (<3 hrs)',
  flight_medium: 'Flight (3-6 hrs)',
  flight_long: 'Flight (>6 hrs)',
  hotel_stay: 'Hotel Stay',
  waste: 'Waste (Generic)',
  waste_landfill: 'Waste - Landfill',
  waste_recycling: 'Waste - Recycling',
  waste_compost: 'Waste - Compost'
};

